import React from 'react';

import { useRegulatoryCodes } from '../../../../../fetchHooks/useRegulatoryCodes';
import useTranslation from '../../../../../hooks/useTranslation';
import useFormContext from '../../form/useFormContext';

const CategorySummary: React.FC = () => {
    const translated = useTranslation();
    const { state } = useFormContext();
    const { data: regulatoryCodes } = useRegulatoryCodes();

    const chosenRegulatoryCode = regulatoryCodes?.find(
        (regulatoryCode) => regulatoryCode.code === state.regulatoryCode,
    );

    return (
        <li key="categorySummary" className="category__list-item">
            <h3 className="summary-description__title">{translated.crossBorderPayment.summary.category}</h3>
            <dl className="summary-description__term-list">
                <dt className="summary-description__spacing-to-title summary-description__term">
                    {translated.crossBorderPayment.summary.chosenCategory}
                </dt>
                <dd className="summary-description__info">{chosenRegulatoryCode?.description}</dd>
            </dl>
        </li>
    );
};

export default CategorySummary;
